import { objectfyArray } from "../helpers/objectfyArray";

const invoices = (state = {}, action) => {
  Object.freeze(state);
  let newState;
  switch (action.type) {
    case "SET_INVOICES":
      if (Array.isArray(action.invoices)) {
        return objectfyArray(action.invoices);
      } else {
        return action.invoices;
      }
    case "SET_INVOICE":
      return {
        ...state,
        [action.invoice.id]: action.invoice,
      };
    case "REMOVE_INVOICES":
      return {};
    case "REMOVE_INVOICE":
      newState = {
        ...state,
      };
      delete newState[action.invoice.id];
      return newState;
    case "ADD_TEMP_INVOICE":
      if (action.invoice) {
        const id = action.invoice.id;
        return {
          ...state,
          [id]: action.invoice,
        };
      }

      return {
        ...state,
        newInvoice: {
          id: "newInvoice",
          appId: action.appId,
          name: "",
          description: "",
          invoiceItems: [],
          orderCustomerInfo: {
            email: "",
            firstName: "",
            lastName: "",
            phone: "",
          },
        },
      };
    case "UPDATE_TEMP_INVOICE":
      newState = {
        ...state,
      };
      delete newState.newInvoice;
      return {
        ...newState,
        [action.invoice.id]: action.invoice,
      };
    case "UPDATE_INVOICE":
      newState = {
        ...state,
      };
      newState[action.invoice.id] = action.invoice;
      return newState;
    default:
      return state;
  }
};

export default invoices;
